import { ApiResource } from '@future-harry/nxt-styles';
import { Address, City } from '@future-harry/nxt-vue-library';

export interface AddressAutocompleteConfig {
   placesApiKey: string;
   placesIndex: string;
}

export function useAddressAutocomplete() {
   const placesApiKey = import.meta.env.VITE_APP_PLACES_API_KEY;
   const placesIndex = import.meta.env.VITE_APP_PLACES_INDEX;

   async function searchCities(searchQuery: string) {
      const response = await http.get<ApiResource<Array<City>>>(`/nxt-cities`, {
         params: { search: searchQuery, include: 'country' },
      });
      return response?.data?.data ?? [];
   }

   async function getAddress(placeId: string) {
      const response = await http.get<ApiResource<Partial<Address>>>(`/places/${placeId}`, {
         params: { include: 'city.country' },
      });
      return response?.data?.data;
   }

   return {
      placesApiKey,
      placesIndex,
      searchCities,
      getAddress,
   };
}
